// extracted by mini-css-extract-plugin
export default {"root":"DetailedTariffBenefitsPopup__root--Vf_Q8"};